import type { CSSProperties, ReactNode } from "react";
import { MetricValue, type MetricValueSize } from "./MetricValue";

export interface MetricStatProps {
  label: string;
  value: ReactNode;
  detail?: ReactNode;
  exactValue?: string;
  size?: MetricValueSize;
  /** Placement in its band, e.g. a grid span set by the band. */
  style?: CSSProperties;
}

/** One figure in a summary band. Labels, values and context remain readable in narrow cells. */
export function MetricStat({
  label,
  value,
  detail,
  exactValue,
  size = "compact",
  style,
}: MetricStatProps) {
  return (
    <div className="min-w-0" style={style}>
      <dt className="text-metric-caption font-medium text-secondary">{label}</dt>
      <dd className="mt-1">
        <MetricValue size={size} title={exactValue}>
          {value}
        </MetricValue>
        {detail != null ? (
          <span className="mt-0.5 block break-words text-metric-detail text-muted">{detail}</span>
        ) : null}
      </dd>
    </div>
  );
}
